module.exports = __webpack_public_path__ + "static/img/banner_anuncio_gol.3b607e59.jpg";